module.exports = __webpack_public_path__ + "img/763C39_431510_210504_55241C-256px.900cdd42.png";